import { createFileEmbed } from '@mono-widgets/file-embeds';

export const app = createFileEmbed();
